export const CampaignNameChangedIcon = ({ className, size = 27, ...props }) => (
    <svg
        {...props}
        width={size}
        height={size}
        viewBox="0 0 27 27"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.5 13.7513H8L12.5 17.2513V5.41797L8 9.5H1.5V13.7513Z"
            stroke="#899CBD"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.5 18.0833V13.75H6.5V18.0833C6.5 18.9118 5.82843 19.5833 5 19.5833C4.17157 19.5833 3.5 18.9118 3.5 18.0833Z"
            stroke="#899CBD"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20.5264 2.41797C20.8209 2.17766 21.2557 2.19512 21.5303 2.46973L22.5303 3.46973C22.8232 3.76262 22.8232 4.23738 22.5303 4.53027L18.7803 8.28027C18.6757 8.38488 18.5425 8.45627 18.3975 8.48535L17.1475 8.73535C16.9016 8.78453 16.647 8.70759 16.4697 8.53027C16.2924 8.35296 16.2155 8.09843 16.2646 7.85254L16.5146 6.60254C16.5437 6.45749 16.6151 6.32434 16.7197 6.21973L20.4697 2.46973L20.5264 2.41797Z"
            stroke="#899CBD"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default CampaignNameChangedIcon
